const host = 'https://lucknowlions_web_back.techharmony.co.in';
// const host = 'http://localhost:8010';

const v = 'v1';


export {host,v};